module.exports = __webpack_public_path__ + "static/img/gjsc3.62fe374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/gjsc3.jpg
// module id = IXsM
// module chunks = 0